import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import StepsCardLines from './step-card-line';
import styles from './style.css';

class ChatCards extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }


    render() {
        const { step, stepLast,mode } = this.props;

        return (
            <div>
                {step.cards && step.cards.map((item, index) => (
                    <div style={{position:'relative'}} key={item.id}>
                        <StepsCardLines cardContent={item} stepLast={stepLast} cardLast={index === step.cards.length - 1 ? true :false} mode={mode} />
                        {
                            step.cards.length > 1 && index !== step.cards.length - 1 && <div className={ item.reply ? styles.verticalBarRight :styles.verticalBar}></div>
                        }
                    </div>
                ))}
            </div>
        );
    }
}

export default ChatCards;
